export default "__VITE_ASSET__Bol5JUOY__"